import React, { useState, useEffect } from "react"
import style from "./SearchFilter.module.scss"
import { Button } from "src/blitz"
import { IDefaultSearchFilter } from "./types"
import { TranslateComponent, useBulkTanslate } from "src/common/translations"

const translationKeys = {
  clearSearch: "Clear Search",
  searching: "Searching",
  search: "Search"
}

const SearchFilter = (props: IDefaultSearchFilter) => {
  const {
    searchByLabel = "",
    onChangeInput,
    onClickSearch = () => null,
    defaultInputValue = "",
    className = "",
    searching = false
  } = props
  //   const [selectedType, selectType] = useState(defaultSearchType)
  const [searchInput, setInputValue] = useState(defaultInputValue)
  const [translations, setTranslations] = useState(translationKeys)
  const bulkTranslate = useBulkTanslate()
 
  useEffect(() => {
    bulkTranslate(translationKeys).then(setTranslations)
  }, [bulkTranslate])

  const onChangeSearchInput = (value: string) => {
    setInputValue(value)
    onChangeInput && onChangeInput(value)
  }

  return (
    <div className={`${style.searchFilter} ${className}`}>
      <p>{searchByLabel ? searchByLabel : <TranslateComponent>Search By Name</TranslateComponent>}</p>
      <div className={style.inputSearchContainer}>
        <input
          type="text"
          value={searchInput}
          onChange={(e: any) => onChangeSearchInput(e.target.value)}
        />
        <div
          title={translations.clearSearch}
          className={style.inputClearSearch}
          onClick={() => onChangeSearchInput("")}
        >
          <span className="clear icon icon-critical"></span>
        </div>
      </div>
      <Button
        type="button"
        onClick={() => onClickSearch(searchInput)}
        hoverVariant="dark"
        btnSize="mini"
        className={style.searchFilterButton}
      >
        {searchInput && searching ? `${translations.searching}...` : translations.search}
      </Button>
    </div>
  )
}

export default SearchFilter
